import React from 'react';
import './StatCard.styles.scss';

interface StatCardProps {
  value: string;
  label: string;
}

// Format number with US-style comma separators
const formatNumber = (value: string): string => {
  // Remove any existing commas and whitespace
  const cleanedValue = value.replace(/,/g, '').trim();

  // Check if it's a valid number (including decimals)
  const numberValue = parseFloat(cleanedValue);

  // If it's a valid number, format it with commas
  if (!isNaN(numberValue) && isFinite(numberValue)) {
    // Use toLocaleString with US locale for comma formatting
    return numberValue.toLocaleString('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    });
  }

  // If not a number, return the original value
  return value;
};

const StatCard: React.FC<StatCardProps> = ({ value, label }) => {
  const formattedValue = formatNumber(value);

  return (
    <div className="stat-card">
      <div className="stat-value">{formattedValue}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

export default StatCard;
